import { authHeader, history } from "../_helpers";
import config from "../config";
import axios from "axios";
const baseUrl = config.apiGateway.baseUrl;
export const wantedHistoryService = {
  createUpdateHistory,
  getWantedHistory,
  getWantedHistoryByAccusedDistrict,
  getWantedHistoryByAccusedCity,
  getWantedHistoryCount,
  getWantedHistoryListCityWise,
};
function createUpdateHistory(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/createUpdateWantedHistory`, requestOptions);
}
function getWantedHistory(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/wantedHistory`, requestOptions);
}
function getWantedHistoryByAccusedDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getWantedHistoryByAccusedDistrict`,
    requestOptions,
  );
}
function getWantedHistoryByAccusedCity(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/getWantedHistoryByAccusedCity`,
    requestOptions,
  );
}
function getWantedHistoryCount(values){
   const requestOptions = {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       ...authHeader(),
     },
     body: JSON.stringify(values),
   };
   return fetch(`${baseUrl}/criminal/getWantedHistoryCount`, requestOptions);
}
function getWantedHistoryListCityWise(values){
   const requestOptions = {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       ...authHeader(),
     },
     body: JSON.stringify(values),
   };
   return fetch(
     `${baseUrl}/criminal/getWantedHistoryListCityWise`,
     requestOptions
   );
}